<template>
    <form class="support" v-bind:action="apiUrl + '/support'" v-on:submit.prevent="handleSubmit">
        <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
            <label class="form__label" for="name">{{ __('Name') }}</label>
            <input class="form__control is-large" id="name" type="text" autocomplete="off"
                   v-bind:placeholder="__('Enter name')"
                   v-model="name"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Email') }}</label>
            <input class="form__control is-large" id="email" type="email" autocomplete="off"
                   v-bind:placeholder="__('Enter email')"
                   v-model="email"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.subject }">
            <label class="form__label" for="subject">{{ __('Subject') }}</label>
            <input class="form__control is-large" id="subject" type="text" autocomplete="off"
                   v-bind:placeholder="__('Enter subject')"
                   v-model="subject"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.subject">{{ errors.subject[0] }}</small>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.message }">
            <label class="form__label" for="message">{{ __('Message') }}</label>
            <textarea class="form__control" id="message"
                   v-bind:placeholder="__('Enter message')"
                   v-model="message"
            ></textarea>
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.message">{{ errors.message[0] }}</small>

        <button class="btn is-primary edit-profile__save-btn">{{ __('Send') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            this.init();
        },
        data: function () {
            return {
                email: '',
                errors: {},
                message: '',
                name: '',
                subject: ''
            }
        },
        methods: {
            handleSubmit: function (e) {
                eventBus.$emit('show-loader');

                const form = e.target;
                const action = form.getAttribute('action');

                this.$http.post(action, {
                    email: this.email,
                    message: this.message,
                    name: this.name,
                    subject: this.subject
                }).then(function (response) {
                    eventBus.$emit('show-alert', 'success', response.body.original.message);
                    eventBus.$emit('hide-loader');
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                    eventBus.$emit('hide-loader');
                });
            },
            init: function () {
                eventBus.$emit('show-loader');

                this.email = this.user.email;
                this.name = this.user.name;

                eventBus.$emit('hide-loader');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Support.vue